import { render, staticRenderFns } from "./LoginExternoEscritoriov2.vue?vue&type=template&id=91c49c38&scoped=true&"
import script from "./LoginExternoEscritoriov2.vue?vue&type=script&lang=js&"
export * from "./LoginExternoEscritoriov2.vue?vue&type=script&lang=js&"
import style0 from "./LoginExternoEscritoriov2.vue?vue&type=style&index=0&id=91c49c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c49c38",
  null
  
)

export default component.exports